import { GetContentPackageDiscussionStatusMeta, GetContentPackageDiscussionStatusPayload } from 'types/store/GetContentPackageDiscussionStatus';
import { createAsyncReducer } from 'utils/Redux';

import { getContentPackageDiscussionStatusActions } from '../actions';

export default createAsyncReducer<GetContentPackageDiscussionStatusMeta, GetContentPackageDiscussionStatusPayload>(getContentPackageDiscussionStatusActions);
